import { createRequestTypes } from '../utils';

export const PROCESSTYPE_LIST = createRequestTypes('processType/PROCESSTYPE_LIST');
export const ADD_PROCESSTYPE = 'processType/ADD_PROCESSTYPE';
export const EDIT_PROCESSTYPE = 'processType/EDIT_PROCESSTYPE';
export const SAVE_PROCESSTYPE = createRequestTypes('processType/SAVE_PROCESSTYPE');
export const PROCESSTYPEREF_LIST = createRequestTypes('processType/PROCESSTYPEREF_LIST');
